import React, { useState, useEffect } from "react";
import { Paper } from "@material-ui/core";
import { Alert, Badge, Button, Modal, Table } from "react-bootstrap";
import TextInput from "../../../components/TextInput";
import { useSelector, useDispatch } from "react-redux";
import { baseUrl } from "../../../services/config";
import { useHistory } from "react-router-dom";
import { useAlert } from "react-alert";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import AddUserCampuses from "./AddUserCampuses";
import { Form, Formik } from "formik";
import { Link } from "react-router-dom";

const UserCampuses = () => {
  const history = useHistory();
  const alert = useAlert();
  // const [state, setstate] = useState(initialState)
  const [first_name, setfirstname] = useState("");
  const [last_name, setlastname] = useState("");
  const [title, settitle] = useState("");
  const [address, setaddress] = useState("");
  const [area, setarea] = useState("");
  const [city, setcity] = useState("");
  const [province, setprovince] = useState("");
  const [deleteModal, setdeleteModal] = useState(false);
  const [longitude, setlongitude] = useState("");
  const [latitude, setlatitude] = useState("");
  const [email, setemail] = useState("");
  const [password, setpassword] = useState("");
  const [SearchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(false);
  let [errorcreate, seterrorcreate] = useState("Please fill all fields");
  let [isallfields, setisallfields] = useState(false);

  const [deleteId, setDeleteId] = useState("");
  const [modalvisible, setmodalvisible] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [addloading, setaddloading] = useState(false);
  const [viewModal, setviewModal] = useState(false);
  const [usersData, setUsersData] = useState([]);
  const [subjectsData, setSubjectsData] = useState([]);

  let authToken = localStorage.getItem("userToken");
  const [selectedUser, setSelectedUser] = useState("");
  const [selectedId, setSelectedId] = useState("");
  const [userCampuses, setUserCampuses] = useState([]);

  const user = useSelector((state) => state.user.user);
  const [campuses, setallcampuses] = useState(user.campuses || []);
  const [selectedCampus, setSelectedCampus] = useState("");
  const [allClasses, setAllClasses] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");
  const [allSections, setAllSections] = useState([]);
  const [selectedSection, setSelectedSection] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  useEffect(() => {
    GetAllUsers();
    getSubjects();
  }, []);

  const GetAllUsers = async () => {
    await fetch(`${baseUrl}/users`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setUsersData(data.payload);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const getSubjects = async () => {
    await fetch(`${baseUrl}/subject`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setSubjectsData(data.payload);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const onCampusChange = async (id) => {
    setSelectedCampus(id);
    getCampusClasses(id);
    setAllClasses([]);
    setSelectedClass("");
    setAllSections([]);
    setSelectedSection("");
  };

  const getCampusClasses = (id) => {
    fetch(`${baseUrl}/campusclass/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.payload) {
          setAllClasses(data.payload);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onClassChange = (selectedCampus, id) => {
    setSelectedClass(id);
    setAllSections([]);
    setSelectedSection("");

    fetch(`${baseUrl}/class_section/${selectedCampus}/1/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setAllSections([...data.payload]);
      })
      .catch((err) => {
        console.log("section error", err);
      });
  };

  const handleUserChange = (value) => {
    setSelectedUser(value);
    if (value) {
      getUserCampuses(value);
    } else {
      setUserCampuses([]);
    }
  };

  const getUserCampuses = (selectedUser) => {
    setLoading(true);

    fetch(`${baseUrl}/user-campuses-classes-sections/user/${selectedUser}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata.success) {
          setUserCampuses(data.payload);
          setLoading(false);
        } else {
          alert.error("No Record Found");
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const openDelete = (row) => {
    setDeleteId(row.id);
    setdeleteModal(true);
  };

  const DeleteHeadofficeHandler = (id) => {
    fetch(`${baseUrl}/user-campuses-classes-sections/${deleteId}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((res) =>
        res.json().then((data) => {
          if (data.metadata.success == true) {
            alert.success("User Campus Deleted Successfull");
            setdeleteModal(false);
            getUserCampuses(selectedUser);
          } else {
            alert.error("something went wrong!");
            setdeleteModal(false);
          }
        }),
      )
      .catch((err) => {
        console.log(err);
        setdeleteModal(false);
      });
  };

  const middleFunc = (row) => {
    setSelectedUser(row?.user_id);
    getCampusClasses(row?.campus_id);
    setSelectedClass(row?.student_class_id);
    onClassChange(row?.campus_id, row?.student_class_id); // pass both
    setSelectedSection(row?.global_section_id);
    setSelectedSubject(row?.subject_id || row?.subject?.id || "");
    setSelectedId(row?.id);
    setSelectedCampus(row?.campus_id); // can stay here too
    setEditModal(true);
  };

  const updateUserCampusHandle = () => {
    if (
      selectedCampus == "" ||
      selectedClass == "" ||
      selectedSection == "" ||
      selectedSubject == "" ||
      selectedUser == ""
    ) {
      setisallfields(true);
      setLoading(false);
      return;
    }
    const data = {
      user_id: selectedUser,
      campus_id: selectedCampus,
      student_class_id: selectedClass,
      global_section_id: selectedSection,
      subject_id: selectedSubject,
    };

    setLoading(true);
    fetch(`${baseUrl}/user-campuses-classes-sections/${selectedId}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) =>
        res.json().then((data) => {
          if (data.metadata.success) {
            alert.success("User Campus Updated Successfully");
            setLoading(false);
            setEditModal(false);
            getUserCampuses(selectedUser);
          } else {
            alert.error("User Campus Not Updated");
            setLoading(false);
            setEditModal(false);
          }
        }),
      )
      .catch((err) => {
        console.log(err);
        setLoading(false);
        setEditModal(false);
      });
  };

  return (
    <Paper className="mt-4 mb-4 p-5">
      <div>
        <button
          className="btn btn-primary"
          onClick={() => setmodalvisible(true)}
          style={{ margin: 5 }}
        >
          Add User Campuses
        </button>
      </div>

      <div className="row mt-5 mb-5">
        <div className="col-md-4">
          <label className="form-label">
            <b>Select User</b> <span style={{ color: "red" }}> *</span>
          </label>
          <select
            className="form-select"
            name="user_id"
            style={{ height: 37 }}
            aria-label="Default select example"
            value={selectedUser}
            onChange={(e) => handleUserChange(e.target.value)}
          >
            <option value="">Select User</option>
            {usersData &&
              usersData.map((item, index) => (
                <>
                  <option key={index} value={item?.id}>
                    {item?.first_name + " " + item?.last_name}
                  </option>
                </>
              ))}
          </select>
        </div>
      </div>

      <Table>
        <thead>
          <tr className="text-center">
            <th>Sr.No</th>
            <th style={{ textAlign: "start" }}>User Name</th>
            <th>Campus</th>
            <th>Classes</th>
            <th>Sections</th>
            <th>Subjects</th>
            <th>Edit</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          {userCampuses &&
            userCampuses.map((row, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td
                  style={{ textAlign: "start" }}
                >{`${row?.user?.first_name} ${row?.user?.last_name}`}</td>
                <td>{row?.campus?.name}</td>
                <td>{row?.student_class?.name}</td>
                <td>{row?.global_section?.name}</td>
                <td>
                  {row?.subject?.name ||
                    (Array.isArray(row?.subjects)
                      ? row.subjects.map((subject) => subject.name).join(", ")
                      : "") ||
                    row?.subject_name ||
                    subjectsData.find(
                      (subject) =>
                        String(subject.id) === String(row?.subject_id),
                    )?.name ||
                    "-"}
                </td>

                <td>
                  <span
                    onClick={() => middleFunc(row)}
                    style={{ cursor: "pointer" }}
                    className="svg-icon svg-icon-md svg-icon-primary-custom"
                  >
                    <SVG
                      src={toAbsoluteUrl(
                        "/media/svg/icons/Communication/Write.svg",
                      )}
                    />
                  </span>
                </td>
                <td>
                  <span
                    onClick={() => openDelete(row)}
                    style={{ cursor: "pointer" }}
                    className="svg-icon svg-icon-md svg-icon-danger"
                  >
                    <SVG
                      src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")}
                    />
                  </span>
                </td>
              </tr>
            ))}
        </tbody>
      </Table>

      <div className="row justify-content-center">
        {loading ? <span className="spinner-border"></span> : null}
      </div>

      <AddUserCampuses
        reload={(createdUserId) => {
          GetAllUsers();
          setSelectedUser(createdUserId);
          getUserCampuses(createdUserId);
        }}
        onHide={() => setmodalvisible(false)}
        show={modalvisible}
        subjectsData={subjectsData}
      />

      <Modal show={deleteModal}>
        <Modal.Header className="modal_header_style" closeButton>
          <Modal.Title
            className="Modal_Heading_font"
            id="contained-modal-title-vcenter"
          >
            Are you sure want to delete user (campus, class, section)
          </Modal.Title>
        </Modal.Header>
        <Modal.Footer>
          <button onClick={DeleteHeadofficeHandler} className="btn button_blue">
            Delete
          </button>
          <button
            onClick={() => setdeleteModal(false)}
            className="btn btn-danger btn_width"
          >
            Cancel
          </button>
        </Modal.Footer>
      </Modal>

      {/* Edit  */}
      <Modal
        size="lg"
        show={editModal}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header className="modal_header_style" closeButton>
          <Modal.Title
            className="Modal_Heading_font"
            id="contained-modal-title-vcenter"
          >
            Update User Campus
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {addloading ? (
            <b style={{ color: "green" }}>
              User Campus Updating Please Wait {` `}{" "}
              <span className="spinner-border"></span>
            </b>
          ) : (
            <div>
              <div className="form-group row">
                <div className="col-lg-6">
                  <label className="form-label">
                    <b>Select User</b> <span style={{ color: "red" }}> *</span>
                  </label>
                  <select
                    disabled
                    className="form-select"
                    name="user_id"
                    style={{ height: 37 }}
                    aria-label="Default select example"
                    value={selectedUser}
                    onChange={(e) => handleUserChange(e.target.value)}
                  >
                    <option value="">Select User</option>
                    {usersData &&
                      usersData.map((item, index) => (
                        <>
                          <option key={index} value={item?.id}>
                            {item?.first_name + " " + item?.last_name}
                          </option>
                        </>
                      ))}
                  </select>
                </div>
                <div className="col-lg-6">
                  <label>
                    <b>Select Campus</b>
                    <span style={{ color: "red", fontSize: 12 }}>*</span>
                  </label>
                  <select
                    className="form-select h-40px"
                    name="campus_id"
                    value={selectedCampus}
                    onChange={(e) => onCampusChange(e.target.value)}
                    aria-label="Default select example"
                  >
                    <option value="">Select Campus</option>
                    {campuses.map((campus, index) => (
                      <option key={index} value={campus.id}>
                        {campus.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="form-group row">
                <div className="col-lg-6">
                  <label>
                    <b>Select Class</b>
                    <span style={{ color: "red", fontSize: 12 }}>*</span>
                  </label>
                  <select
                    className="form-select h-40px"
                    name="class_id"
                    value={selectedClass}
                    onChange={(e) =>
                      onClassChange(selectedCampus, e.target.value)
                    }
                    aria-label="Default select example"
                  >
                    <option value="">Select Class</option>
                    {allClasses.map((campus, index) => (
                      <option key={index} value={campus.id}>
                        {campus.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-lg-6">
                  <label>
                    <b>Select Section</b>
                    <span style={{ color: "red", fontSize: 12 }}>*</span>
                  </label>

                  <select
                    className="form-select h-40px"
                    name="section_id"
                    value={selectedSection}
                    onChange={(e) => setSelectedSection(e.target.value)}
                    aria-label="Default select example"
                  >
                    <option value="">Select Section</option>
                    {allSections.map((sec, index) => (
                      <option key={index} value={sec.id}>
                        {sec.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="form-group row">
                <div className="col-lg-6">
                  <label>
                    <b>Select Subject</b>
                    <span style={{ color: "red", fontSize: 12 }}>*</span>
                  </label>
                  <select
                    className="form-select h-40px"
                    name="subject_id"
                    value={selectedSubject}
                    onChange={(e) => setSelectedSubject(e.target.value)}
                    aria-label="Default select example"
                  >
                    <option value="">Select Subject</option>
                    {subjectsData.map((subject) => (
                      <option key={subject.id} value={subject.id}>
                        {subject.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {isallfields ? (
                <>
                  <Alert
                    variant="danger"
                    onClose={() => setisallfields(false)}
                    dismissible
                  >
                    <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                    <p>{errorcreate}</p>
                  </Alert>
                </>
              ) : null}

              <br />
              <div className="d-flex justify-content-end">
                <button
                  type="submit"
                  className="btn btn-primary mx-4"
                  onClick={() => updateUserCampusHandle()}
                  disabled={loading}
                >
                  Update
                </button>

                <Link to="/user-campuses">
                  <button
                    onClick={() => {
                      setisallfields(false);
                      setSelectedCampus("");
                      setSelectedClass("");
                      setSelectedSection("");
                      setSelectedSubject("");
                      setEditModal(false);
                    }}
                    type="button"
                    className="btn btn-danger"
                  >
                    Cancel
                  </button>
                </Link>
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </Paper>
  );
};

export default UserCampuses;
